import { useEvidencePermission } from '@utils/permission-hook';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ApiFilterOperation, EmptyComponent, Evidence } from '@eas/common-web';
import { useAuthoredEvidence } from '@components/evidence/authored-evidence';
import { AuditCompany } from '@models';
import {
  AuditingEntityType,
  EvidenceApiUrl,
  ExportTag,
  Permission,
} from '@enums';
import { ActionBar } from './audit-company-actionbar';
import { useColumns } from './audit-company-columns';
import { Fields } from './audit-company-fields';
import { useAuditCompanyHookedSources } from './audit-company-hooked-sources';
import { useValidationSchema } from './audit-company-schema';

export function AuditCompanies() {
  const columns = useColumns();
  const validationSchema = useValidationSchema();
  const permissions = useEvidencePermission([
    Permission.BO_AUDITING_ENTITY_MANAGE,
  ]);

  const evidence = useAuthoredEvidence<AuditCompany>({
    version: 5,
    identifier: 'AUDIT_COMPANY',
    apiProps: {
      url: EvidenceApiUrl.AUDITING_ENTITY,
      hookedSources: useAuditCompanyHookedSources,
    },
    tableProps: {
      columns,
      tableName: 'Audítorské spoločnosti',
      showBulkActionButton: false,
      reportTag: ExportTag.AUDIT_COMPANY,
      defaultPreFilters: [
        {
          field: 'type.id',
          operation: ApiFilterOperation.EQ,
          value: AuditingEntityType.AUDIT_COMPANY,
        },
      ],
    },
    detailProps: {
      toolbarProps: {
        title: 'Audítorská spoločnosť',
        showBtn: permissions,
        ActionBar,
      },
      FieldsComponent: Fields,
      GeneralFieldsComponent: EmptyComponent,
      validationSchema,
      initNewItem: () => ({
        id: uuidv4(),
        type: AuditingEntityType.AUDIT_COMPANY,
      }),
    },
  });

  return <Evidence {...evidence} />;
}
